import {
    ChangeDetectionStrategy,
    Component,
    ViewChild,
} from '@angular/core';
import { UiModalComponent } from '@components';
import { IProcess } from '@models';
import { ProcessService } from '@services';

import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ProcessSettingsComponent } from '../../shared';

@Component({
    templateUrl: './process-settings.modal.html',
    providers: [
        ProcessService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProccessSettingsModalComponent
    extends UiModalComponent<IProcess> {

    public loading$ = new BehaviorSubject(false);

    @ViewChild('processSetting', { static: true })
    public processSetting!: ProcessSettingsComponent;

    private _processService = this._injector.get<ProcessService>(ProcessService);

    public onSubmit() {
        if (this.processSetting.form.invalid) {
            return;
        }

        this.loading$.next(true);
        this._processService
            .patch(this.context.data.id, {
                processSettings: this.processSetting.form.value,
            })
            .pipe(
                finalize(() => this.loading$.next(false)),
            )
            .subscribe(() => {
                this.closeModal();
            });
    }
}
